import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';

const ItemQVSIHRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnCenter uiColumn200">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "location" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "profile" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue className="uiBlue" format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "sih" }} />
            </li>
        </ul>
    )
}

export default ItemQVSIHRow
